<template>
    <div class="mbb-points-list fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">代理商资源点</span>
            <el-form
                inline
                class="right themed-form search-form"
                :model="form"
                style="line-height: 40px"
            >
                <el-form-item label="代理商:">
                    <AgentSelect
                        :multiple="false"
                        v-model="form.agentId"
                        :placeholder="'全部'"
                    />
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select
                        v-model="form.status"
                        clearable
                        placeholder="全部"
                    >
                        <el-option label="全部" value="" />
                        <el-option label="正常" value="0" />
                        <el-option label="停用" value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="onSearch"
                        v-preventReClick
                        >搜索查询</el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="onOpenAdd"
                        v-preventReClick
                        >新增代理商资源点</el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="exportChange"
                        v-preventReClick
                        >导出</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="代理商"
                    prop="agentName"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="总资源点"
                    prop="totalPoints"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="已用资源点"
                    prop="usedPoints"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="剩余资源点"
                    prop="remainPoints"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="套餐充值资源点"
                    prop="packageRechargePoints"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="状态"
                    prop="status"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{ formatStatus(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="备注"
                    prop="remark"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="更新时间"
                    prop="updateTime"
                    show-overflow-tooltip
                />
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            />
        </div>

        <el-dialog
            title="新增代理商资源点"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            @close="onDialogClose"
            v-if="dialogVisible"
            width="520px"
        >
            <el-form
                :model="addForm"
                :rules="addRules"
                ref="addForm"
                label-width="110px"
            >
                <el-form-item label="代理商:" prop="agentId">
                    <AgentSelect
                        :multiple="false"
                        v-model="addForm.agentId"
                        :placeholder="'请选择代理商'"
                        @change="onAddAgentChange"
                    />
                </el-form-item>
                <el-form-item label="备注:">
                    <el-input
                        v-model="addForm.remark"
                        type="textarea"
                        :rows="3"
                        maxlength="200"
                        show-word-limit
                        placeholder="请输入备注"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="onSubmitAdd"
                    v-preventReClick
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="dialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import resize from "@/mixins/resize.js";
import AgentSelect from "@/components/AgentSelect.vue";
import {
    listPoints,
    savePoints,
    exportPoints,
} from "@/api/MbbManagement/pointsList.js";
import { agentListForUser } from "@/api/cardManagement/cardBill.js";

export default {
    name: "MbbPointsList",
    mixins: [resize],
    components: { AgentSelect },
    data() {
        return {
            form: {
                agentId: "",
                status: "",
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            dialogVisible: false,
            addForm: {
                agentId: "",
                remark: "",
            },
            addRules: {
                agentId: [
                    {
                        required: true,
                        message: "请选择代理商",
                        trigger: "change",
                    },
                ],
            },
            // 用于根据 agentId 反查 agentName
            agentOptions: [],
        };
    },
    mounted() {
        this.getList();
        this.fetchAgentOptions();
    },
    methods: {
        // 列表
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form,
            };
            listPoints(params).then((res) => {
                if (res && res.page) {
                    this.tableData = res.page.rows || [];
                    this.total = res.page.total || 0;
                    this.currentPage = res.page.pageNo || 1;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        // 代理商选项（用于新增时取名称）
        fetchAgentOptions() {
            agentListForUser()
                .then((res) => {
                    this.agentOptions = Array.isArray(res) ? res : [];
                })
                .catch(() => {
                    this.agentOptions = [];
                });
        },
        // 搜索
        onSearch() {
            this.currentPage = 1;
            this.getList();
        },
        // 分页
        handleSizeChange(v) {
            this.pageSize = v;
            this.getList();
        },
        handleCurrentChange(v) {
            this.currentPage = v;
            this.getList();
        },
        // 新增弹窗
        onOpenAdd() {
            this.addForm = { agentId: "", remark: "" };
            this.dialogVisible = true;
            if (!this.agentOptions.length) {
                this.fetchAgentOptions();
            }
            this.$nextTick(() => {
                // 打开时清理上次校验提示
                this.$refs.addForm && this.$refs.addForm.clearValidate();
            });
        },
        onAddAgentChange() {
            // 仅用于触发校验
            this.$nextTick(() => {
                this.$refs.addForm &&
                    this.$refs.addForm.clearValidate("agentId");
            });
        },
        onDialogClose() {
            // 关闭时重置表单与校验状态，防止下次打开仍显示错误提示
            this.$refs.addForm &&
                this.$refs.addForm.resetFields &&
                this.$refs.addForm.resetFields();
        },
        async onSubmitAdd() {
            this.$refs.addForm.validate(async (valid) => {
                if (!valid) return;
                const agent =
                    this.agentOptions.find(
                        (it) => (it.agentId || it.id) === this.addForm.agentId
                    ) || {};
                const agentName = agent.agentName || agent.name || "";
                try {
                    this.$modal && this.$modal.loading("保存中...");
                    const payload = {
                        agentId: this.addForm.agentId,
                        agentName: agentName,
                        totalPoints: 0,
                        usedPoints: 0,
                        remainPoints: 0,
                        packageRechargePoints: 0,
                        flowTotalMb: 0,
                        flowUsedMb: 0,
                        status: 0,
                        remark: this.addForm.remark || "",
                    };
                    const res = await savePoints(payload);
                    if (res && String(res.system_result_key) === "0") {
                        this.$modal
                            ? this.$modal.msgSuccess("保存成功")
                            : this.$message.success("保存成功");
                        this.dialogVisible = false;
                        this.getList();
                    } else {
                        const msg =
                            (res && res.system_result_message_key) ||
                            "保存失败";
                        this.$modal
                            ? this.$modal.msgError(msg)
                            : this.$message.error(msg);
                    }
                } finally {
                    this.$modal &&
                        this.$modal.closeLoading &&
                        this.$modal.closeLoading();
                }
            });
        },
        // 显示状态文本
        formatStatus(v) {
            if (String(v) === "0") return "正常";
            if (String(v) === "1") return "停用";
            return "";
        },
        // 导出
        exportChange() {
            let params = {
                agentId: this.form.agentId || "",
                status: this.form.status || "",
            };
            exportPoints(params).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list');
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
.mbb-points-list {
    padding: 20px;
}
.content-box {
    margin-bottom: 20px;
}
.pagination {
    text-align: right;
    margin-top: 20px;
}
.mbb-points-list /deep/ .el-form--inline .el-form-item__content {
    vertical-align: middle;
}
</style>


